import { render, staticRenderFns } from "./HomeLink.vue?vue&type=template&id=71b1b458"
import script from "./HomeLink.vue?vue&type=script&lang=js"
export * from "./HomeLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports